import { z } from 'zod';

export const ExperienceSelectionSchema = z.object({
  experience: z.string(),
});
